import { useEffect } from "react";

/**
 * Injects one or more Schema.org JSON-LD blocks into <head>.
 * Accepts a single object or an array of objects. `null`/`undefined` entries
 * are skipped. Cleans up on unmount.
 */
export default function JsonLd({ data }) {
  useEffect(() => {
    const items = Array.isArray(data) ? data.filter(Boolean) : [data].filter(Boolean);
    const nodes = items.map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
  }, [JSON.stringify(data)]);
  return null;
}
